import { useContext } from 'react'
import { ErrorMessage } from '@hookform/error-message'
import { yupResolver } from '@hookform/resolvers/yup'
import { LoaderContext } from 'contexts/loader-context'
import { useSession } from 'contexts/session-context'
import Button from 'components/button'
import Input from 'components/input'
import { useForm } from 'react-hook-form'
import formServices from 'services/form-builder-services'
import ProfileService from 'services/profile-services'
import { AxiosError } from 'axios'
import { Label } from 'theme/theme'
import textServices from 'services/text-services'

function Names({ state, nextStep, handleChange, prevStep, htmlSteps, setError }: any) {
  const {
    register,
    handleSubmit,
    formState: { errors }
  } = useForm({ resolver: yupResolver(formServices.formGenerateSchema(['firstName', 'lastName', 'nickName'])) })
  const { setLoad } = useContext(LoaderContext)
  const [{ user }] = useSession()

  const validateNickName = async (nickName: string) => {
    setLoad(true)
    try {
      await ProfileService.validateNickName(nickName)
      nextStep()
    } catch (error) {
      if ((error as AxiosError).isAxiosError) {
        gtag('event', 'Click', {
          event_category: GTM_EVENT_CATEGORY,
          event_label: 'SINGUP - NickName existente',
          value: '10'
        })
        return setError((error as AxiosError).response?.data.code ?? 9999)
      }
    } finally {
      setLoad(false)
    }
  }

  const onFormSubmit = async (data: any) => {
    handleChange(data)
    const { nickName } = data
    if (user?.nickName?.trim()?.toLowerCase() !== nickName?.trim()?.toLowerCase()) {
      return validateNickName(nickName)
    }
    gtag('event', 'step_1', {
      event_label: 'Registro - Email',
      method: "Email"
    })
    nextStep()
  }

  return (
    <div className="flex flex-col flex-1 md:pt-10">
      <div className="flex flex-row items-center justify-around w-full mb-4">{htmlSteps}</div>
      <form
        className="flex h-full justify-between flex-col gap-4 mx-7 mb-7"
        onSubmit={handleSubmit(onFormSubmit)}
        noValidate
      >
        <div className="flex-1 flex flex-col gap-4">
          <div className="gap-2 flex flex-col">
            <Label className="text-start text-2xl font-bold uppercase">{textServices.findByText('profile/form/information/firstname/label', '¿Cómo te llamas?')}</Label>
            <Input
              className="text-center saira font-bold text-sm"
              type="text"
              placeholder={textServices.findByText('profile/form/information/firstname/placeholder', 'PON TU NOMBRE AQUÍ')}
              name="firstName"
              defaultValue={state?.firstName}
              {...register('firstName')}
            />
            <ErrorMessage errors={errors} name="firstName" />
            <Input
              className="text-center saira font-bold text-sm"
              type="text"
              placeholder={textServices.findByText('profile/form/information/lastname/placeholder', "PON TU APELLIDO AQUÍ")}
              name="lastName"
              defaultValue={state?.lastName}
              {...register('lastName')}
            />
            <ErrorMessage errors={errors} name="lastName" />
          </div>
          <div className="gap-2 flex flex-col">
            <Label className="text-start text-2xl font-bold uppercase">{textServices.findByText('profile/form/information/nickname/label', "Apodo")}</Label>
            <Input
              className="text-center saira font-bold text-sm"
              type="text"
              placeholder={textServices.findByText('profile/form/information/nickname/placeholder', "¿COMO TE GUSTA QUE TE LLAMEN?")}
              name="nickName"
              defaultValue={state?.nickName}
              {...register('nickName')}
            />
            <ErrorMessage errors={errors} name="nickName" />
          </div>
        </div>
        <Button>
          <p className="uppercase">Siguiente</p>
        </Button>
        <button
          type="button"
          className="cursor-pointer"
          onClick={() => {
            gtag('event', 'Click', {
              event_category: GTM_EVENT_CATEGORY,
              event_label: 'MODIFICAR INFORMACION - Volver atras',
              value: '10'
            })
            prevStep()
          }}
        >
          <p className={`din text-center mt-3 hover:text-red-100 uppercase underline`} style={{ fontSize: 10 }}>
            VOLVER
          </p>
        </button>
      </form>
    </div>
  )
}

export default Names
